import TransactionsPage from "./TransactionsPage";

export default function AccountStatementPage() {
  return <TransactionsPage accountStatementMode />;
}
